// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1v3El","footer":"styles_footer__1ikJI","passCodeTooltip":"styles_passCodeTooltip__1aCtr"};